import { Auth0Provider } from "@auth0/auth0-react";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import history from './utils/history';
import { ThemeProvider } from "@material-ui/styles";
import { CssBaseline } from "@material-ui/core";

import Themes from "./themes";
import App from "./components/App";
import * as serviceWorker from "./serviceWorker";
import configureStore from './configureStore';
import {
  AUTH0_DOMAIN,
  AUTH0_CLIENT_ID,
  AUTH0_AUDIENCE,
  AUTH0_LOGIN_REDIRECT_URI
} from './utils/constants';
// Create redux store with history
const initialState = {};
const store = configureStore(initialState, history);
const MOUNT_NODE = document.getElementById('root');
const themParam = {
  logo: 'https://www.alanai.co/images/favicon.png'
}

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
        <ThemeProvider theme={Themes.default}>
          <Auth0Provider
            domain={AUTH0_DOMAIN}
            clientId={AUTH0_CLIENT_ID}
            redirectUri={AUTH0_LOGIN_REDIRECT_URI}
            audience={AUTH0_AUDIENCE}
            scope="read:current_user update:current_user_metadata"
            theme ={themParam}
          >
            <CssBaseline />
            <App />
          </Auth0Provider>
        </ThemeProvider>
      </ConnectedRouter>
  </Provider>,
  MOUNT_NODE,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
